export default __webpack_public_path__ + "static/media/DashboardAsistencia.3e1363e7.svg";